export default "__VITE_ASSET__BaY1waCW__"